import { isMcpFlow } from '../hooks/useMcpFlow';
import { createFileRoute, redirect } from '../utils';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context, location }) => {
    if (isMcpFlow()) {
      throw redirect({
        to: '/signup/mcp/complete',
      });
    }

    const isAuthenticated = context.authentication?.isAuthenticated;
    if (!isAuthenticated) {
      const shouldRedirect = location.href !== '/';

      const options = shouldRedirect
        ? {
            search: {
              redirect: location.href,
            },
          }
        : {};

      throw redirect({
        ...options,
        to: '/login',
      });
    } else {
      throw redirect({
        to: '/app',
      });
    }
  },
  component: () => <div />,
});
